<div class="contractors-main-container"> 
  <div 
    class="contractors-body-container" 
    [class.overlay-open]="isOverlayOpen" 
  > 
    <!-- Added by Amisha on 07/16/2026 to reuse the renewals-style top bar for contractor registrations. --> 
    <div 
      class="header-row" 
      [class.header-row-hidden]="!isRegistrationTabActive()" 
    > 
      <app-common-filterbuilder-staff-janus 
        [placeholder]="'Search Contractors'" 
        (search)="onSearch($event)" 
        (attributeSelect)="onAttribute($event)" 
        [attributeOptions]="filterCriteria" 
        [myWorkOptions]="myWorkOptions" 
        (filterChanged)="onFilterChanged($event)" 
        [useMuiLayout]="true" 
        [attributePopoverClass]="'contractors-attribute-popover'" 
        [local_storage_key]="FILTER_CACHE_KEY" 
        [externalFilterInputs]="externalFilters" 
        (externalFilterInputsChange)="onExternalFiltersChanged($event)" 
        [customTemplate]="exportsButtonTemplate" 
        [id]="'contractors-table'" 
      > 
      </app-common-filterbuilder-staff-janus> 
 
      <ng-template #exportsButtonTemplate> 
        <app-scheduled-exports-janus 
          [componentId]="id" 
          [title]="title" 
          [params]="filterCriteria" 
          [currentFilters]="filterOptions" 
          [currentColumnOptions]="columnOptions" 
          [separateDropdown]="false" 
          (exportExcel)="exportExcel()" 
          (exportCsv)="exportCsv()" 
        ></app-scheduled-exports-janus> 
      </ng-template> 
    </div> 
 
    <button
      class="mobile-start-application-button"
      *ngIf="isRegistrationTabActive()"
      type="button"
      [matMenuTriggerFor]="contractorApplicationsMenu"
      [disabled]="isStartingContractorApplication"
    >
      Start New Application
    </button>

    <!-- Added by Amisha on 07/16/2026 to split contractor registrations and contractor types into separate tabs. --> 
    <div class="tabs-row" [class.has-mobile-start-application]="isRegistrationTabActive()"> 
      <a 
        class="tab-button" 
        [class.active]="isTabActive('all')" 
        [routerLink]="['all']" 
        (click)="ensureRegistrationData()" 
      > 
        Contractor Registrations 
      </a> 
      <a 
        class="tab-button" 
        [class.active]="isTabActive('types')" 
        [routerLink]="['types']" 
      > 
        Contractor Types 
      </a> 
      <button
        class="start-new-application-button"
        *ngIf="isRegistrationTabActive()"
        type="button"
        style="margin-left: auto; border: 0; background: transparent; color: #0875d1; cursor: pointer; font: inherit; padding: 0 0 8px;"
        [matMenuTriggerFor]="contractorApplicationsMenu"
        [disabled]="isStartingContractorApplication"
      >
        Start New Application
      </button>
      <mat-menu #contractorApplicationsMenu="matMenu" xPosition="before" yPosition="below">
        <div style="min-width: 250px; max-height: 320px; overflow-y: auto;">
          <div *ngIf="contractorRegistrationWorkflows.length > 4" style="position: sticky; top: 0; z-index: 1; background: #fff; padding: 12px 8px 8px; box-sizing: border-box;" (click)="$event.stopPropagation()" (keydown)="$event.stopPropagation()">
            <wm-common-textfield
              [data]="contractorSearchFieldConfig"
              [(ngModel)]="contractorWorkflowSearch"
            ></wm-common-textfield>
          </div>
          <div *ngIf="isContractorWorkflowLoading" style="padding: 10px 16px;">Loading contractor registrations...</div>
          <div *ngIf="contractorWorkflowError" style="padding: 10px 16px;" role="alert">{{ contractorWorkflowError }}</div>
          <button
            mat-menu-item
            *ngFor="let workflow of displayedContractorWorkflows"
            [disabled]="isStartingContractorApplication"
            (click)="startContractorRegistration(workflow.id)"
          >
            <span style="font-weight: 400;">{{ workflow.version?.name || workflow.name }}</span>
          </button>
          <div
            *ngIf="!isContractorWorkflowLoading && !contractorWorkflowError && !displayedContractorWorkflows.length"
            style="padding: 10px 16px;"
          >
            No contractor registrations found
          </div>
        </div>
      </mat-menu>
    </div> 
 
    <div *ngIf="contractorWorkflowError && !isStartingContractorApplication" role="alert">{{ contractorWorkflowError }}</div>
 
    <!-- Added by Amisha on 07/16/2026 to keep the registration table directly under the tabs like renewals. --> 
    <ng-container *ngIf="isRegistrationTabActive(); else contractorTypesContent"> 
      <div class="data-table-main-container"> 
        <router-outlet></router-outlet> 
      </div> 
    </ng-container> 
 
    <ng-template #contractorTypesContent> 
      <!-- Added by Amisha on 07/16/2026 to preserve the existing contractor types shell and scrolling behavior. --> 
      <div class="inner-body-container types-shell"> 
        <div class="inner-body-scroll"> 
          <router-outlet></router-outlet> 
        </div> 
      </div> 
    </ng-template> 
  </div> 
 
  <router-outlet name="overlay"></router-outlet> 

  <div
    *ngIf="isStartingContractorApplication"
    class="contractor-start-loader"
    role="status"
    aria-label="Starting contractor registration"
  >
    <app-loader></app-loader>
  </div>
</div> 